export class LetterTemplate {
  constructor({ id = 0, title = null, docFile = docFile } = {}) {
    this.id = id;
    this.title = title;
    this.docFile = docFile;
  }
}
